<div
  class="code-block -parent"
  [class.code-block--light]="colour === 'light'"
  [class.code-block--dark]="colour === 'dark'">
  @if (tabs.length > 1) {
  <ul class="code-block -nav" [class.is-fixed]="fixed && !mobile" #nav>
    @for (tab of tabs; track tab) { @if (tab) {
    <li>
      <button type="button" (click)="onSelect(tab.titleCode)" [class.is-active]="tab.title === selectedLanguage">
        {{ tab.title }}
      </button>
    </li>
    } }
  </ul>
  }
  <div class="code-block -results">
    <button class="code-block -copy-button" (click)="onCopyClick()">
      Copy
    </button>
    <div class="code-block -success" [class.is-animating]="successAnimating">Copied!</div>
    <div class="-main-code" #results>
      <ng-content></ng-content>
    </div>
  </div>
</div>
